import {
  IS_FETCHING_ACTIVITY_MASTER_DATA,
  ACTIVITY_MASTER_DATA,
  ACTIVITY_MASTER_ERROR_MESSAGE,
} from '../actions/constants';

const defaultState: any = {
  activityMaster: {},
  isFetchingMasterData: false,
  errorMessage: null,
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case ACTIVITY_MASTER_DATA: {
      return {
        ...state,
        activityMaster: action.data,
        isFetchingMasterData: false,
      };
    }
    case IS_FETCHING_ACTIVITY_MASTER_DATA: {
      return {
        ...state,
        isFetchingMasterData: true,
      };
    }
    case ACTIVITY_MASTER_ERROR_MESSAGE: {
      return {
        ...state,
        errorMessage: action.errorMessage,
        isFetchingMasterData: false,
      };
    }
    default: return state;
  }
}
